<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <nb-card class="dialog-card">
    <nb-card-header>
      <h4>
        {{ (isEdit ? "learningBlockCases.dialog.editTitle" : "learningBlockCases.dialog.newTitle") | translate }}
      </h4>
    </nb-card-header>

    <nb-card-body>
      <div class="field-row">
        <div class="form-field">
          <label class="label">{{ "learningBlockCases.dialog.component" | translate }} *</label>
          <nb-select
            fullWidth
            size="small"
            formControlName="component"
            [placeholder]="'learningBlockCases.dialog.componentPlaceholder' | translate"
          >
            @for (o of componentOptions; track o.id) {
              <nb-option [value]="o.id">{{ o.label }}</nb-option>
            }
          </nb-select>
        </div>
        <div class="form-field">
          <label class="label">{{ "learningBlockCases.dialog.polarity" | translate }} *</label>
          <nb-select fullWidth size="small" formControlName="polarity">
            <nb-option value="use">{{ "learningBlockCases.polarity.use" | translate }}</nb-option>
            <nb-option value="avoid">{{ "learningBlockCases.polarity.avoid" | translate }}</nb-option>
          </nb-select>
        </div>
      </div>

      <div class="form-field">
        <label class="label" for="lbc-situation">{{ "learningBlockCases.dialog.situation" | translate }} *</label>
        <textarea
          id="lbc-situation"
          nbInput
          fullWidth
          rows="3"
          formControlName="situation"
          [maxlength]="limits.textMax"
          [placeholder]="'learningBlockCases.dialog.situationPlaceholder' | translate"
        ></textarea>
        <div class="hint-row">
          <span class="hint">{{ "learningBlockCases.dialog.situationHint" | translate }}</span>
          <span class="counter">{{ length("situation") }} / {{ limits.textMax }}</span>
        </div>
        @if (hasError("situation", "maxlength")) {
          <span class="field-error">{{ "learningBlockCases.dialog.tooLong" | translate: { max: limits.textMax } }}</span>
        }
      </div>

      <div class="form-field">
        <label class="label" for="lbc-action">{{ "learningBlockCases.dialog.action" | translate }} *</label>
        <textarea
          id="lbc-action"
          nbInput
          fullWidth
          rows="3"
          formControlName="action"
          [maxlength]="limits.textMax"
          [placeholder]="'learningBlockCases.dialog.actionPlaceholder' | translate"
        ></textarea>
        <div class="hint-row">
          <span class="hint">{{ "learningBlockCases.dialog.actionHint" | translate }}</span>
          <span class="counter">{{ length("action") }} / {{ limits.textMax }}</span>
        </div>
        @if (hasError("action", "maxlength")) {
          <span class="field-error">{{ "learningBlockCases.dialog.tooLong" | translate: { max: limits.textMax } }}</span>
        }
      </div>

      <div class="form-field">
        <label class="label" for="lbc-anchors">{{ "learningBlockCases.dialog.anchors" | translate }}</label>
        <input
          id="lbc-anchors"
          nbInput
          fullWidth
          fieldSize="small"
          formControlName="anchors"
          [placeholder]="'learningBlockCases.dialog.anchorsPlaceholder' | translate"
        />
        @if (anchors.length) {
          <div class="chips" [attr.aria-label]="'learningBlockCases.dialog.anchors' | translate">
            @for (a of anchors; track $index) {
              <span class="chip" [class.chip--too-long]="a.length > limits.anchorMax">{{ a }}</span>
            }
          </div>
        }
        <div class="hint-row">
          <span class="hint">
            {{ "learningBlockCases.dialog.anchorsHint" | translate: { max: limits.anchorsMax, chars: limits.anchorMax } }}
          </span>
          <span class="counter">{{ anchors.length }} / {{ limits.anchorsMax }}</span>
        </div>
        @if (hasError("anchors", "tooManyAnchors")) {
          <span class="field-error">
            {{ "learningBlockCases.dialog.anchorsTooMany" | translate: { max: limits.anchorsMax } }}
          </span>
        }
        @if (hasError("anchors", "anchorTooLong")) {
          <span class="field-error">
            {{ "learningBlockCases.dialog.anchorTooLong" | translate: { chars: limits.anchorMax } }}
          </span>
        }
      </div>

      <div class="field-row">
        <div class="form-field">
          <label class="label" for="lbc-valid-until">{{ "learningBlockCases.dialog.validUntil" | translate }}</label>
          <input id="lbc-valid-until" nbInput fullWidth fieldSize="small" type="date" formControlName="valid_until" />
          <span class="hint">{{ "learningBlockCases.dialog.validUntilHint" | translate }}</span>
        </div>
        @if (!isEdit) {
          <div class="form-field">
            <label class="label">{{ "learningBlockCases.dialog.status" | translate }}</label>
            <nb-select fullWidth size="small" formControlName="status">
              <nb-option value="active">{{ "learningBlockCases.status.active" | translate }}</nb-option>
              <nb-option value="suggested">{{ "learningBlockCases.status.suggested" | translate }}</nb-option>
            </nb-select>
            <span class="hint">{{ "learningBlockCases.dialog.statusHint" | translate }}</span>
          </div>
        }
      </div>
    </nb-card-body>

    <nb-card-footer>
      <button nbButton status="basic" size="small" type="button" (click)="close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button nbButton status="primary" size="small" type="submit" [disabled]="saving" [nbSpinner]="saving">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
